<template>
  <div class="content-body">
    <div class="top">广告组</div>
    <div class="body">
      <el-button type="primary" icon="el-icon-plus" size="small" @click="addPlan">新建广告计划</el-button>
      <div class="condition">
        <div class="form">
          <div class="demo-input-suffix">
            广告主:
            <el-select v-model="form.type" placeholder="请选择活动区域" size="small" style="width: 160px; margin-left: 10px;">
              <el-option label="不限" value=""></el-option>
              <el-option :label="company_name" value="1"></el-option>
            </el-select>
          </div>
          <div class="demo-input-suffix">
            广告组:
            <el-input v-model="form.keyword" placeholder="" style="width: 160px; margin-left: 10px;" size="small"></el-input>
          </div>
          <div class="demo-input-suffix">
            广告组状态:
            <el-select v-model="form.status" placeholder="请选择活动区域" size="small" style="width: 160px; margin-left: 10px;">
              <el-option label="不限" value=""></el-option>
              <el-option label="开启" value="1"></el-option>
              <el-option label="关闭" value="0"></el-option>
            </el-select>
          </div>
          <el-button type="primary" @click="search" size="small">查询</el-button>
        </div>
        <div class="other">
          <div class="demo-input-suffix">
            时间:
            <el-date-picker v-model="form.time" type="date" placeholder="选择日期" style="width: 160px; margin-left: 10px;" size="small"></el-date-picker>
          </div>
          <div class="demo-input-suffix">
            是否查询数据量值:
            <el-switch v-model="form.isData" style="margin-left: 10px;" @change="getData()"></el-switch>
          </div>
        </div>
      </div>
      <div class="table">
        <el-table :data="tableData" border show-summary style="width: 1371px" size="small" @cell-mouse-enter="rowChange" @cell-mouse-leave="leaveRow" sum-text="汇总" :header-cell-style="{ 'background-color': '#F4F4F4', 'font-weight': 'bold', 'color': '#333' }">
          <el-table-column prop="id" label="开关" width="80" align="center">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.status" @change="changeStatusOne(scope.$index)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column width="200" label="广告组" align="center">
            <template slot-scope="scope">
              <a href="javascript:;" @click="adv_lists_call_back(scope.row.plan_id)">{{ scope.row.title }}</a>
              <i style="color: #0782C3; font-size: 14px; cursor: pointer; margin-left: 3px;" @click="editOne2(scope.$index)" class="el-icon-edit-outline" v-if="scope.row['isShowEditIcon'] !== undefined && scope.row['isShowEditIcon']"></i>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="广告主" width="200" align="center">
            <template>
              {{ company_name }}
            </template>
          </el-table-column>
          <el-table-column prop="read" label="展现" width="110" align="center"></el-table-column>
          <el-table-column prop="click" label="点击" width="110" align="center"></el-table-column>
          <el-table-column prop="click_p" label="点击率" width="110" align="center"></el-table-column>
          <el-table-column prop="cpc" label="cpc" width="110" align="center"></el-table-column>
          <el-table-column prop="cpm" label="cpm" width="110" align="center"></el-table-column>
          <el-table-column prop="pay" label="消耗(元)" width="120" align="center"></el-table-column>
          <el-table-column label="预算(元)" width="120" align="center">
            <template slot-scope="scope">
              {{ parseInt(scope.row.budget) >= '999999999998' ? '不限' : scope.row.budget }}
              <i style="color: #0782C3; font-size: 14px; cursor: pointer;" @click="editOne(scope.$index)" class="el-icon-edit-outline" v-if="scope.row['isShowEditIcon'] !== undefined && scope.row['isShowEditIcon']"></i>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="100">
            <template slot-scope="scope">
              <!-- <el-button type="text" size="mini" @click="editOne(scope.$index)">编辑</el-button> -->
              <el-button type="text" style="color: red;" size="mini" @click="delOne(scope.row.plan_id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="page-c">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10, 20, 30, 40, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageTotal">
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="修改广告预算" :close-on-click-modal="false" :visible.sync="dialogVisible" width="30%">
      <el-form ref="form" label-width="80px" label-position="left">
        <el-form-item label="原预算">
          <el-input v-model="old_input" placeholder="" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="新预算">
          <el-input v-model="input" placeholder=""></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="sure" size="mini">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="修改广告组名" :close-on-click-modal="false" :visible.sync="dialogVisible2" width="30%">
      <el-form ref="form" label-width="100px" label-position="left">
        <el-form-item label="原广告组名">
          <el-input v-model="old_title" placeholder="" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="新广告组名">
          <el-input v-model="title" placeholder=""></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button @click="dialogVisible2 = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="sure2" size="mini">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'index',
  data() {
    return {
      form: {
        status: '',
        type: '',
        keyword: '',
        isData: true,
        time: ''
      },
      dialogVisible: false,
      dialogVisible2: false,
      page: 1,
      checked: 1,
      old_input: '',
      old_title: '',
      input: '',
      title: '',
      plan_id: 0,
      pageSize: 10,
      pageTotal: 1,
      tableData: [],
      company_name: ''
    };
  },
  mounted() {
    this.company_name = JSON.parse(sessionStorage.getItem('user_info'))['company_name'];
    const day2 = new Date();
    day2.setTime(day2.getTime());
    this.form.time = day2.getFullYear() + '-' + (day2.getMonth() + 1) + '-' + day2.getDate();
    this.getData();
  },
  methods: {
    rowChange(row, column, cell, event) {
      this.$set(row, 'isShowEditIcon', true);
      // row['isShowEditIcon'] = true;
    },
    leaveRow(row, column, cell, event) {
      this.$set(row, 'isShowEditIcon', false);
    },
    getData() {
      this.$http.post('/trader/plan/getPlanLists', {
        status: this.form.status,
        keyword: this.form.keyword,
        page: this.page,
        pageSize: this.pageSize,
        isData: this.form.isData
      }).then(res => {
        if (res.code === 200) {
          this.tableData = res.data;
          this.pageTotal = Math.ceil(res.count / this.pageSize);
          this.$function.hiddenLoading();
        }
      });
    },
    handleSizeChange(value) {
      this.page = 1;
      this.pageSize = value;
      this.getData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.getData();
    },
    search() {
      this.tableData = [];
      this.page = 1;
      this.getData();
    },
    addPlan() {
      this.$emit('add_plan', 'plan');
    },
    editOne(index) {
      const item = this.tableData[index];
      this.old_input = item.budget;
      this.input = '';
      this.plan_id = item.plan_id;
      this.dialogVisible = true;
    },
    sure() {
      if (this.input === '') {
        this.$message.error('请输入新预算');
        return false;
      }
      this.$http.post('/trader/plan/editPlan', {
        plan_id: this.plan_id,
        budget_type: 1,
        budget: this.input
      }).then(res => {
        if (res.code === 200) {
          this.dialogVisible = false;
          this.getData();
        }
      });
    },
    editOne2(index) {
      const item = this.tableData[index];
      this.old_title = item.title;
      this.title = '';
      this.plan_id = item.plan_id;
      this.dialogVisible2 = true;
    },
    sure2() {
      if (this.title === '') {
        this.$message.error('请输入新广告组名');
        return false;
      }
      this.$http.post('/trader/plan/editPlanTitle', {
        plan_id: this.plan_id,
        title: this.title
      }).then(res => {
        if (res.code === 200) {
          this.dialogVisible2 = false;
          this.getData();
        }
      });
    },
    delOne(plan_id) {
      if (plan_id > 0) {
        this.$http.post('/trader/plan/delPlan', {
          plan_id
        }).then(res => {
          if (res.code === 200) {
            this.getData();
          }
        });
      }
    },
    adv_lists_call_back(plan_id) {
      this.$emit('adv_lists_call_back', plan_id);
    },
    changeStatusOne(index) {
      const val = this.tableData[index].status ? 1 : 0;
      this.$http.post('/trader/plan/changePlanStatus', {
        plan_id: this.tableData[index].plan_id,
        value: val
      }).then(res => {
        if (res.code === 200) {
          this.getData();
          this.ids = [];
          this.$message.success('操作成功，仅审核通过的创意可修改状态');
        } else {
          this.$message.error('操作失败');
        }
      });
    }
  },
  watch: {

  }
};
</script>

<style lang="less" scoped>
  .top {
    height: 54px;
    background-color: #f9f9f9;
    margin-bottom: 31px;
    font-size: 16px;
    font-weight: 700;
    line-height: 54px;
    color: #333;
    padding-left: 22px;
  }
  .body {
    width: calc(100% - 69px);
    margin-left: 23px;
    width: 1400px;
    .condition {
      margin-top: 20px;
      width: 1400px;
      height: 55px;
      .form {
        float: left;
        width: 950px;
      }
      .other {
        float: right;
        width: 440px;
      }
      .demo-input-suffix {
        display: inline-block;
        font-size: 14px;
        color: #999;
        margin-right: 31px;
      }
    }
    .page-c {
      margin-top: 20px;
      text-align: right;
      margin-right: 30px;
    }
  }

</style>
